import Marquee from "react-fast-marquee";

const ITEMS = ["B2B Wholesale", "Chef's Table", "Local Mount Albert", "Luxury Organic Produce", "Hardneck Asiatic Garlic", "Farm Gate Pickup"];

export const MarqueeRibbon = () => (
  <div data-testid="marquee-ribbon" className="border-y border-line bg-obsidian py-8 overflow-hidden">
    <Marquee speed={18} gradient={false}>
      {ITEMS.map((t, i) => (
        <span key={t} className="mx-10 flex items-center gap-10">
          <span
            className={`font-display text-3xl sm:text-4xl tracking-tight whitespace-nowrap ${
              i % 2 ? "text-outline italic" : "text-zinc-200"
            }`}
          >
            {t}
          </span>
          <span className="w-2 h-2 rotate-45 bg-saffron inline-block shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
